module.exports = __webpack_public_path__ + "static/img/6.cf56371.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/eng/6.png
// module id = DV7E
// module chunks = 0